'use client';

import Script from 'next/script';

const DEFAULT_GA_ID = 'G-Z9GQZ4NYLV';

interface GoogleAnalyticsProps {
    measurementId?: string;
}

export function GoogleAnalytics({ measurementId }: GoogleAnalyticsProps) {
    const gaId = measurementId || process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || DEFAULT_GA_ID;

    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
            />
            <Script
                id="google-analytics"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}');
          `,
                }}
            />
        </>
    );
}

